export const COOKIE_LIFETIME_LONG = 8640000 // 100 days
export const COOKIE_LIFETIME_MEDIUM = 604800 // 7 days
export const COOKIE_PREFERED_AUTH_MODE = "oabat.auth.preselect"

export const COOKIE_PREVIOUS_SEARCH_ROUTE =
    "oabat.routing.previous_search_route"

export const COOKIE_CONSENT = "oabat.cookie.consent"
